<template>
    <a-card>
    <h3 style="text-align: center;margin:20px 0 40px">报告正文</h3>
        <a-descriptions size="middle" :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }">
            <a-descriptions-item :span="2" label="报告简要" name="brief">{{form.brief}}</a-descriptions-item>
            <a-descriptions-item :span="2" label="报告正文" name="text">{{form.text}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>

    import { projectReporttext } from "@/api/TechnologieprojekteApply";
    import {
        formMixin
    } from "@/mixins";
    export default {
        name: "报告正文",
        mixins: [formMixin],
        components: {
        },
        data() {
            return {
                options: null,
                form:{
                },
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectReporttext.detailByProject,
                    params: { 
                        projectId: this.$route.query.projectId,
                        classification: this.$route.query.classification,
                     }
                }).then((res) => {
                    if(res){
                        this.form = res
                    }
                });
            }
        }

    }
</script>
